module.exports = __webpack_public_path__ + "static/media/email-white.06319002.png";